var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app_header",
      attrs: { "data-bg": _vm.bgColor, id: "myHeader" }
    },
    [
      _c(
        "div",
        { staticClass: "header_inner" },
        [
          _vm.page == "home"
            ? _c(
                "div",
                {
                  staticClass: "header_news",
                  attrs: {
                    "data-tooltip-displayed": _vm.displayedTooltip
                      ? "true"
                      : "false"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "news_bt",
                      on: {
                        click: function($event) {
                          _vm.displayedTooltip = !_vm.displayedTooltip
                        }
                      }
                    },
                    [_vm._v("Last Update")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "news_tooltip",
                      attrs: {
                        "data-displayed": _vm.displayedTooltip
                          ? "true"
                          : "false"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tooltip_closebt",
                          on: {
                            click: function($event) {
                              return _vm.hideTooltip()
                            }
                          }
                        },
                        [_vm._v("Hide")]
                      ),
                      _c("div", { staticClass: "tooltip_date" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.fixedNewsData.date) +
                            "\n                "
                        )
                      ]),
                      _c("div", {
                        staticClass: "tooltip_text",
                        domProps: {
                          innerHTML: _vm._s(_vm.fixedNewsData.description)
                        }
                      }),
                      _c("div", { staticClass: "tooltip_link" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.fixedNewsData.link,
                              target: "_blank"
                            }
                          },
                          [_vm._v("Read more")]
                        )
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _c("nuxt-link", { staticClass: "header_logo", attrs: { to: "/" } }),
          _c("div", { staticClass: "header_sticky_title" }, [
            _vm._v(_vm._s(_vm.stickyTitle))
          ]),
          _c("div", {
            staticClass: "header_burgerbt",
            class: _vm.mobileMenuDisplayed ? "opened" : "",
            on: {
              click: function($event) {
                _vm.mobileMenuDisplayed = !_vm.mobileMenuDisplayed
              }
            }
          }),
          _c(
            "div",
            {
              staticClass: "header_menu",
              attrs: {
                "data-mobiledisplayed": _vm.mobileMenuDisplayed
                  ? "true"
                  : "false"
              }
            },
            [
              _c(
                "div",
                { staticClass: "header_head" },
                [
                  _c("nuxt-link", {
                    staticClass: "header_logo",
                    attrs: { to: "/" }
                  }),
                  _c("div", {
                    staticClass: "header_burgerclosebt",
                    on: {
                      click: function($event) {
                        _vm.mobileMenuDisplayed = false
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "header_content" },
                [
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "menu_item",
                      class:
                        _vm.page == "home" && !_vm.expandMoreBlock
                          ? "selected"
                          : "",
                      attrs: { to: "/", "data-item": "home" }
                    },
                    [
                      _vm.mobileMenuDisplayed
                        ? _c("span", [_vm._v("Homepage")])
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "menu_item",
                      class:
                        _vm.page == "dataset" && !_vm.expandMoreBlock
                          ? "selected"
                          : "",
                      on: {
                        click: function($event) {
                          return _vm.clickMenuItem("dataset")
                        }
                      }
                    },
                    [_vm._v("Datasets")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "menu_item",
                      class:
                        _vm.page == "country" && !_vm.expandMoreBlock
                          ? "selected"
                          : "",
                      on: {
                        click: function($event) {
                          return _vm.clickMenuItem("country")
                        }
                      }
                    },
                    [_vm._v("Countries")]
                  ),
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "menu_item",
                      class:
                        _vm.page == "download" && !_vm.expandMoreBlock
                          ? "selected"
                          : "",
                      attrs: { to: "/download-data/" }
                    },
                    [_vm._v("Download data & methodology")]
                  ),
                  !_vm.mobileMenuDisplayed
                    ? _c(
                        "a",
                        {
                          staticClass: "menu_item",
                          class: _vm.expandMoreBlock ? "selected" : "",
                          attrs: { "data-item": "more" },
                          on: {
                            click: function($event) {
                              _vm.expandMoreBlock = !_vm.expandMoreBlock
                            }
                          }
                        },
                        [_vm._v("More")]
                      )
                    : _vm._e(),
                  _vm.mobileMenuDisplayed
                    ? _c(
                        "nuxt-link",
                        {
                          staticClass: "menu_item",
                          attrs: { to: "/research-briefs/" }
                        },
                        [_vm._v("Research briefs")]
                      )
                    : _vm._e(),
                  _vm.mobileMenuDisplayed
                    ? _c(
                        "nuxt-link",
                        {
                          staticClass: "menu_item",
                          attrs: { to: "/teaching-toolkit/" }
                        },
                        [_vm._v("Teaching Toolkit")]
                      )
                    : _vm._e(),
                  _vm.mobileMenuDisplayed
                    ? _c(
                        "nuxt-link",
                        { staticClass: "menu_item", attrs: { to: "/about/" } },
                        [_vm._v("About")]
                      )
                    : _vm._e(),
                  _vm.mobileMenuDisplayed
                    ? _c(
                        "a",
                        {
                          staticClass: "menu_item",
                          on: {
                            click: function($event) {
                              return _vm.gotoContactBlock()
                            }
                          }
                        },
                        [_vm._v("Contact")]
                      )
                    : _vm._e(),
                  _vm.mobileMenuDisplayed
                    ? _c(
                        "nuxt-link",
                        { staticClass: "menu_item", attrs: { to: "/faq/" } },
                        [_vm._v("FAQ")]
                      )
                    : _vm._e(),
                  _vm.mobileMenuDisplayed
                    ? _c("div", { staticClass: "menu_shareblock" }, [
                        _c("div", { staticClass: "shareblock_title" }, [
                          _vm._v("Follow us on")
                        ]),
                        _vm._m(0)
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm.expandMoreBlock
            ? _c(
                "div",
                { staticClass: "header_moreblock" },
                [
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "moreblock_link",
                      attrs: { to: "/research-briefs/" }
                    },
                    [_vm._v("Research briefs")]
                  ),
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "moreblock_link",
                      attrs: { to: "/teaching-toolkit/" }
                    },
                    [_vm._v("Teaching Toolkit")]
                  ),
                  _c(
                    "nuxt-link",
                    { staticClass: "moreblock_link", attrs: { to: "/about/" } },
                    [_vm._v("About")]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "moreblock_link",
                      on: {
                        click: function($event) {
                          return _vm.gotoContactBlock()
                        }
                      }
                    },
                    [_vm._v("Contact")]
                  ),
                  _c(
                    "nuxt-link",
                    { staticClass: "moreblock_link", attrs: { to: "/faq/" } },
                    [_vm._v("FAQ")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col_icons" }, [
      _c("a", { staticClass: "col_icon", attrs: { "data-icon": "fb" } }),
      _c("a", { staticClass: "col_icon", attrs: { "data-icon": "in" } }),
      _c("a", { staticClass: "col_icon", attrs: { "data-icon": "tw" } }),
      _c("a", { staticClass: "col_icon", attrs: { "data-icon": "lk" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32315a63", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32315a63","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/appHeader.vue
// module id = B576
// module chunks = 0 1 2 3 4 5 6 7 8